import { commonUtils, LOCALE_CODE_EN, LOCALE_CODE_FI } from './components/common_utils';

const feedback = {
    issue_type_new_customer: 'N',
    issue_type_new_dealer_location: 'NL',
    seller_code: 'T',
    dealer_code: 'D',

    showHideOption(type) {
        $('#idPrivateIssueType,#idIssueType,.newCustomerText,.newLocationFields,.mobile_instructor_text').hide();
        $('#feedbackType').val(type);
        if (type === this.seller_code) {
            this.changeSellerIssueType();
            $('#sellerIssue').addClass('tab-active');
            $('#dealerIssue').removeClass('tab-active');
            $('#idPrivateIssueType').show();
            $('#formHeading').text(Translations.feedback.seller_contact_form);
            $('#issueType').val('');
        } else {
            $('#sellerIssue').removeClass('tab-active');
            $('#dealerIssue').addClass('tab-active');
            $('#idIssueType').show();
            $('#formHeading').text(Translations.feedback.dealer_contact_form);
            $('#privateIssueType').val('');

            if ($('#issueType').val() === this.issue_type_new_customer) {
                $('.newCustomerText').show();
            }
            if ($('#issueType').val() === this.issue_type_new_dealer_location) {
                $('.newLocationFields').show();
                this.initDatePicker();
            }
        }
    },
    changeSellerIssueType() {
        let $mobileInstructorText = $('.mobile_instructor_text');
        $mobileInstructorText.hide();
    },
    initDatePicker() {
        const $startDateField = $('#newLocationStartDate');
        const locale = commonUtils.getCurrentLocale() === LOCALE_CODE_EN ? LOCALE_CODE_EN : LOCALE_CODE_FI;
        const defaultTranslations = {
            [LOCALE_CODE_FI]: {
                prevText: 'Edellinen',
                nextText: 'Seuraava',
            },
            [LOCALE_CODE_EN]: {
                prevText: 'Previous',
                nextText: 'Next',
            },
        };
        const trans = defaultTranslations[locale];

        $startDateField.datepicker({
            dateFormat: 'dd.mm.yy',
            firstDay: 1,
            monthNames: Translations.datepicker?.monthNames || Object.values(Translations.month_names),
            monthNamesShort: Translations.datepicker?.monthNamesShort || Object.values(Translations.month_short_names),
            dayNames: Translations.datepicker?.dayNames || Translations.days_long,
            dayNamesShort:
                Translations.datepicker?.dayNamesShort ||
                (() => {
                    const d = Translations.days;
                    return [d.sunday, d.monday, d.tuesday, d.wednesday, d.thursday, d.friday, d.saturday];
                })(),
            dayNamesMin:
                Translations.datepicker?.dayNamesMin ||
                (() => {
                    const d = Translations.days;
                    return [d.sunday, d.monday, d.tuesday, d.wednesday, d.thursday, d.friday, d.saturday];
                })(),
            prevText: Translations.datepicker?.prevText || trans.prevText,
            nextText: Translations.datepicker?.nextText || trans.nextText,
            beforeShow(input, inst) {
                setTimeout(function () {
                    inst.dpDiv.addClass('nt-simple-search-datepicker');
                }, 1);
            },
        });
    },
    validate() {
        let $privateIssueType = $('#privateIssueType');
        let $issueType = $('#issueType');
        if ($('#feedbackType').val() === this.dealer_code) {
            if ('' === $issueType.val()) {
                alert(Translations.feedback.validate.issue_type);
                $issueType.focus();
                return false;
            }
        } else if ('' === $privateIssueType.val()) {
            alert(Translations.feedback.validate.issue_type);
            $privateIssueType.focus();
            return false;
        }

        if (!commonUtils.isUserLogin()) {
            let $name = $('#feedbackName');
            let $email = $('#feedbackEmail');
            if (!$name.val()) {
                alert(Translations.feedback.validate.name_blank);
                $name.focus();
                return false;
            }

            if (!$email.val()) {
                alert(Translations.feedback.validate.email_blank);
                $email.focus();
                return false;
            }
            if (!commonUtils.isValidEmail($email.val())) {
                alert(Translations.invalid_email);
                $email.focus();
                return false;
            }
        }

        if (!this.checkAdIds()) {
            let $idAd = $('#feedbackAdId');
            $idAd.val('').focus();
            alert(Translations.feedback.validate.invalid_ad_ids);
            return false;
        }

        let $mobile = $('#feedbackMobile');
        let $message = $('#feedbackMessage');

        // Validate new location fields if NL is selected
        if ($('#issueType').val() === this.issue_type_new_dealer_location) {
            const requiredFields = [
                { id: 'newLocationCompany', key: 'company' },
                { id: 'newLocationAddress', key: 'address' },
                { id: 'newLocationPhone', key: 'phone' },
                { id: 'newLocationLeadEmail', key: 'lead_email' },
                { id: 'newLocationStartDate', key: 'start_date' },
                { id: 'newLocationContactName', key: 'contact_name' },
                { id: 'newLocationContactEmail', key: 'contact_email' },
            ];

            for (let field of requiredFields) {
                let $field = $(`#${field.id}`);
                if (!$field.val()) {
                    alert(Translations.feedback.validate[`new_location_${field.key}_required`]);
                    $field.focus();
                    return false;
                }
            }

            // Validate email fields
            let $leadEmail = $('#newLocationLeadEmail');
            if (!commonUtils.isValidEmail($leadEmail.val())) {
                alert(Translations.feedback.validate.new_location_invalid_email);
                $leadEmail.focus();
                return false;
            }

            let $contactEmail = $('#newLocationContactEmail');
            if (!commonUtils.isValidEmail($contactEmail.val())) {
                alert(Translations.feedback.validate.new_location_invalid_email);
                $contactEmail.focus();
                return false;
            }

            let $locationPhone = $('#newLocationPhone');
            if (!commonUtils.isValidPhone($locationPhone.val())) {
                alert(Translations.feedback.validate.new_location_invalid_phone);
                $locationPhone.focus();
                return false;
            }

            let $adCount = $('#newLocationAdCount');
            if ($adCount.val() !== '' && !/^\d+$/.test($adCount.val())) {
                alert(Translations.feedback.validate.new_location_invalid_ad_count);
                $adCount.focus();
                return false;
            }
        }

        if ($mobile.val() && !commonUtils.isValidPhone($mobile.val())) {
            alert(Translations.feedback.validate.mobile_format);
            $mobile.focus();
            return false;
        }
        if (!$message.val()) {
            alert(Translations.missing_mandatory);
            $message.focus();
            return false;
        }

        $('#feedbackSend').attr('disabled', true);
        document.feedbackForm.submit();
        return true;
    },
    checkAdIds() {
        let adIds = $('#feedbackAdId').val();
        if (adIds) {
            let adList = adIds.split(',');
            for (let value of adList) {
                if (Number.isNaN(value)) {
                    return false;
                }
            }
        }
        return true;
    },
    reset() {
        $('#feedbackForm')[0].reset();
        $('.feedbackImageText').attr('placeholder', '');
    },
};

$(function () {
    feedback.showHideOption($('.tab-active').data('val'));

    // Initialize date picker if new location fields are already visible on page load
    if ($('.newLocationFields').is(':visible')) {
        feedback.initDatePicker();
    }

    // Change dealer/private user tab
    $('.feedbackTypeTab').click(function () {
        feedback.showHideOption($(this).data('val'));
    });

    // Hide/Show new user text
    $('#issueType').change(function () {
        let $newCustomerText = $('.newCustomerText');
        let $newLocationFields = $('.newLocationFields');
        if ($(this).val() === feedback.issue_type_new_customer) {
            $newCustomerText.show();
            $newLocationFields.hide();
        } else if ($(this).val() === feedback.issue_type_new_dealer_location) {
            $newCustomerText.hide();
            $newLocationFields.show();
            feedback.initDatePicker();
        } else {
            $newCustomerText.hide();
            $newLocationFields.hide();
        }
    });

    // When select image, show selected file name
    $('#feedback_image').change(function () {
        $('.feedbackImageText').attr('placeholder', $(this)[0].files[0].name);
    });

    // Private user option change
    $('#privateIssueType').change(function () {
        feedback.changeSellerIssueType();
    });

    // When click on attach button
    $('#chooseAttachments').click(function () {
        $('#feedback_image').click();
    });

    // Submit button
    $('#feedbackSend').click(function () {
        feedback.validate();
    });

    // Reset button
    $('#feedbackReset').click(function () {
        feedback.reset();
    });

    // Load CloudFlare Turnstile JS
    commonUtils.loadCloudFlareTurnstileJs().catch((error) => {
        console.error('Error loading script from feedback :', error);
    });
});
